<template>
  <div ref="host">
    <slot></slot>
  </div>
</template>

<script>
import { Bounds, MapController, defaultBoundsModel, defaultFocusModel, defaultEnvelopeModel } from "vue-niney";

export default {
  name: "NMap",
  props: {
    boundsModel: { type: Object, default: function() { return defaultBoundsModel }},
    focusModel: { type: Object, default: function() { return defaultFocusModel }},
    envelopeModel: { type: Object, default: function() { return defaultEnvelopeModel }},
    mouseWheelAction: { type: String, default: "ZOOM" },
  },
  watch: {
    boundsModel: function(val) {
      val.setBounds(new Bounds(this.$refs.host.offsetWidth, this.$refs.host.offsetHeight));
      this.mapControllerEnv.boundsModel = val;
    },
    focusModel: function(val) {
      this.mapControllerEnv.focusModel = val;
    },
    mouseWheelAction: function(val) {
      this.mapControllerEnv.mouseWheelAction = val;
    }
  },
  mounted: function() {
    this.boundsModel.setBounds(new Bounds(this.$refs.host.offsetWidth, this.$refs.host.offsetHeight));
    
    this.mapControllerEnv = {
      boundsModel: this.boundsModel,
      focusModel: this.focusModel,
      mouseWheelAction: this.mouseWheelAction,
      tapFunction: (x, y, duration, ctrlKey, shiftKey) => { this.$emit("n-tap", x, y, duration, ctrlKey, shiftKey); },
      pressFunction: (x, y) => { this.$emit("n-press", x, y); },
      releaseFunction: (x, y) => { this.$emit("n-release", x, y); },
      mouseMoveFunction: (x, y) => { this.$emit("n-mouse-move", x, y); }
    };
    this.mapController = new MapController(this.$refs.host, this.mapControllerEnv);
  },
  destroyed: function() {
    this.mapController.destroy();
  }
}
</script>

<style scoped>
div {
  position: relative;
}
</style>

